

















import { Component, Vue, Prop } from 'vue-property-decorator';
import Logger from '@/logger';

export enum EnumSizes {
  tiny = 'tiny',
  small = 'small',
  large = 'large',
}

export enum EnumColors {
  primary = 'primary',
  light = 'light',
}

@Component
export default class LoaderCircular extends Vue {
  @Prop({ default: EnumSizes.small }) private size!: EnumSizes;
  @Prop({ default: EnumColors.primary }) color: EnumColors;

  private created() {
    if (!Object.values(EnumSizes).includes(this.size)) {
      Logger.warn(`
        Component ${this.$options.name} does not support size ${this.size}.
        Supported sizes: ${Object.values(EnumSizes)}.
      `);
    }
  }
}
